import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PayDTO } from '../../dtos/dto';
import { IBookingGets, IBookingSetStatus } from '../../interfaces/booking.interface';
import { IPaginationGet } from '../../interfaces/interface';
import { BookingRehabilitationProgramDTO } from './booking-rehabilitation.dto';
import { IBookingRehabiltationProgramCreate } from './booking-rehabilitation.interface';

@Injectable({
  providedIn: 'root',
})
export class BookingRehabilitationApi {
  private readonly apiUrl: string = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  create(booking: IBookingRehabiltationProgramCreate): Observable<BookingRehabilitationProgramDTO[]> {
    return this.http.post<BookingRehabilitationProgramDTO[]>(
      this.apiUrl + `/clinic/rehabilitation-program/booking`,
      booking,
    );
  }

  gets(booking: IBookingGets): Observable<IPaginationGet<BookingRehabilitationProgramDTO[]>> {
    return this.http.post<IPaginationGet<BookingRehabilitationProgramDTO[]>>(
      this.apiUrl + `/clinic/rehabilitation-program/booking/search`,
      booking,
    );
  }

  setStatus(id: number, status: IBookingSetStatus): Observable<BookingRehabilitationProgramDTO> {
    return this.http.post<BookingRehabilitationProgramDTO>(
      this.apiUrl + `/clinic/rehabilitation-program/booking/${id}/status`,
      status,
    );
  }

  pay(id: number): Observable<PayDTO> {
    return this.http.get<PayDTO>(this.apiUrl + `/clinic/rehabilitation-program/booking/${id}/pay`);
  }
}
